<template>
    <bottom-sheet v-model="shows" title="마이스펙 이력 인쇄하기" fullscreen persistent maxWidth="100%" needsLogin v-bind="{ width }">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-layout column justify-center :class="{ 'bottom-sheet__contents h-100': !isPrinting }">
            <application-certification v-bind="{ value }" id="print-target" />
            <v-card-actions class="v-btn-group" id="print-action">
                <v-btn color="primary" class="min-w-140px min-w-lg-160px" @click="print">인쇄하기</v-btn>
            </v-card-actions>
        </v-layout>
    </bottom-sheet>
</template>

<script>
import { initApplication } from "@/assets/variables";

import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import ApplicationCertification from "@/components/dashboard/company/application/application-certification.vue";

export default {
    components: {
        BottomSheet,
        ApplicationCertification,
    },
    props: {
        value: { type: Object, default: initApplication },
    },
    data: () => ({
        shows: false,
        loading: false,
        isPrinting: false,
    }),
    computed: {
        width() {
            return this.isPrinting ? "100%" : "1224";
        },
    },
    methods: {
        print() {
            this.isPrinting = true;

            const targetElm = document.getElementById("print-target");

            const parentElm = targetElm.parentNode;
            parentElm.style.height = "100v";
            parentElm.style.maxHeight = "100%";
            parentElm.style.height = "100%";
            parentElm.style.padding = "0";
            parentElm.style.margin = "0";
            parentElm.style.overflowY = "hidden";

            const actionElm = document.getElementById("print-action");
            actionElm.style.display = "none";

            const headerElm = parentElm.parentNode.parentNode.previousSibling;
            headerElm.style.display = "none";

            setTimeout(() => {
                window.print();
            }, 200);

            setTimeout(() => {
                parentElm.style.height = null;
                parentElm.style.maxHeight = null;
                parentElm.style.height = null;
                parentElm.style.margin = null;
                parentElm.style.overflowY = null;

                actionElm.style.display = null;
                headerElm.style.display = null;

                this.isPrinting = false;
            }, 1000);
        },
    },
};
</script>
